package com.bikompanion.data.cache

import kotlinx.serialization.Serializable

@Serializable
internal data class CachedPoint(
    val latitude: Double,
    val longitude: Double,
)
